import { useState } from "react";

import { IconButton, List, ListItem, ListItemIcon, ListItemSecondaryAction, ListItemText, ListSubheader, TextField } from "@material-ui/core";
import AlternateEmailIcon from '@material-ui/icons/AlternateEmail';
import AddIcon from '@material-ui/icons/Add';
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";

export interface EmailsPickerProps {
  value: string[];
  onChange: (v: string[]) => void;
}

export function EmailsPicker(props: EmailsPickerProps) {
  const { value, onChange } = props;

  const [currentEmail, setCurrentEmail] = useState<string | undefined>(void 0);
  
  const triggerAddEmail = () => {
    if (currentEmail) {
      onChange(
        [...value, currentEmail]
      );
      setCurrentEmail(void 0);
    }
  };

  const triggerDeleteValue = (idx: number) => {
    const valueCopy = [...value];
    valueCopy.splice(idx, 1);

    onChange([...valueCopy]);
  }

  return (
    <List
      style={{width: '100%'}}
      subheader={
        <ListSubheader>
          Indirizzi email
        </ListSubheader>
      }
    >
      {value.map((emailAddress, k) => (
        <ListItem key={k}>
          <ListItemIcon>
            <AlternateEmailIcon />
          </ListItemIcon>
          <ListItemText primary={emailAddress} />
          <ListItemSecondaryAction>
            <IconButton
              onClick={() => triggerDeleteValue(k)}
            >
              <DeleteForeverIcon />
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem>
      ))}
      <ListItem>
        <TextField
          style={{width: '100%'}}
          variant='outlined'
          defaultValue={currentEmail}
          onChange={(evt) => setCurrentEmail(evt.target.value)}
          InputProps={{
            endAdornment: (
              <IconButton 
                disabled={!currentEmail}
                onClick={triggerAddEmail}
              >
                <AddIcon />
              </IconButton>
            )
          }}
        />
      </ListItem>
    </List>
  );
}